import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import {
  SegmentedView,
  SegmentedViewController,
  SegmentedViewData,
} from '../../../components/SegmentedViewController/SegmentedViewOnLine';
import useViewComplaintCount from '../../../hooks/dashboard/BaDriverVerification/useViewComplaintCount';
import { BA_DRIVER_VERIFICATION_VIEW_COMPLAINT_SALES_ADMIN } from '../../../routes/routeConstants';
import BADriverVerificationTable from './BADriverVerificationTable';
import CompanyInfoTable from './CompanyInfoTable';

const segmentedViewControllerTitle = [
  { title: 'Companies' },
  { title: 'BA Agents' },
];

const BA_AGENTS_TAB_INDEX = 1;

const BADriverVerificationSalesAdmin = () => {
  const navigate = useNavigate();
  const { viewComplaintCount, complaintCount } = useViewComplaintCount();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  useEffect(() => {
    viewComplaintCount();
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Driver Verification'>
      <PageLayout noTitle={true}>
        <Container>
          <SegmentsArea>
            <SegmentedView onChange={setActiveTabIndex}>
              <SegmentedViewController
                segmentedViewControllerTitle={segmentedViewControllerTitle}
                actionSlot={
                  activeTabIndex !== BA_AGENTS_TAB_INDEX && (
                    <ViewComplaint
                      // disabled={complaintCount === 0}
                      onClick={() =>
                        navigate(
                          `/${BA_DRIVER_VERIFICATION_VIEW_COMPLAINT_SALES_ADMIN}`,
                        )
                      }
                    >
                      View Complaints <CountSpan>{complaintCount}</CountSpan>
                    </ViewComplaint>
                  )
                }
              />
              <SegmentedViewData>
                <section>
                  <CompanyInfoTable />
                </section>
                <section>
                  <BADriverVerificationTable />
                </section>
              </SegmentedViewData>
            </SegmentedView>
          </SegmentsArea>
        </Container>
      </PageLayout>
    </Page>
  );
};

export default BADriverVerificationSalesAdmin;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SegmentsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: white;
  /* border: 1px solid red; */
`;

const ViewComplaint = styled.button`
  border: 1px solid ${({ theme }) => theme.palette.blueColor};
  color: ${({ theme }) => theme.palette.blueColor};
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
  background: none;
  /* border: none; */

  &:disabled {
    cursor: not-allowed;
  }

  & > svg {
    color: ${({ theme }) => theme.palette.blueColor};
  }
`;

const CountSpan = styled.span`
  background-color: ${({ theme }) => theme.palette.blueColor};
  color: white;
  border-radius: 100%;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
  height: fit-content;
`;
